import React, {Component} from "react";
import Script from "react-load-script";
import {map, isEmpty} from "lodash";
import {message, Select} from "antd";
import * as yup from "yup";
import moment from "moment-timezone";
import {PlusOutlined} from '@ant-design/icons';
import Loader from "../../../Common/Component/Loader";
import AllState from "../../../../Assets/data/stateList.json";
import cross_icon from "../../../../Assets/images/cross_icon.svg";
import { aboutUsData } from "../../../../Assets/data/aboutUsList";
import Axios from 'axios';
const {Option} = Select
const REGULAR_EXPRESSION_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class BasicDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      zipcodeCheck: false,
      zipcode: '',
      franchises: [],
      firstName: '',
      lastName: '',
      address: {address: '', city: '', state: '', zip_code: ''},
      phone_numbers: [],
      emails: [],
      authorizedUser: [],
      phone: '',
      phone_type: 'mobile',
      hear_about_us: [],
      can_send_sms: false,
      email: '',
      isLocalValueChanged: false,
      loader: false,
      is_address_manually: false,
      is_zipcode_change:false,
      basicDetails: {},
      is_dummy_email:false
    }
  }

  componentDidMount = () => {
    //TODO: 
    this.genarateGibberrishEmail(); 
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy();
    const { basicDetails, email } = this.state;
    
    // check zipcode
    if(this.state.is_zipcode_change){
      if (nextProps?.zipcodeCheck && Object.keys(nextProps?.zipcodeCheck?.data).length > 0 && 
        nextProps?.zipcodeCheck?.data?.results?.length > 0) {
        this.setState({
          zipcodeCheck: true,
          franchises: nextProps?.zipcodeCheck?.data?.results,
          errors: {},
          loader: false
        }, () => {
        });
      } else {
        this.setState({
          zipcodeCheck: false,
          franchises: [],
          errors: {},
          loader: false
        });
      }
    }
    
    if(nextProps?.EmailVerifycation)
    {
      if (!nextProps?.EmailVerifycation.data)
      {
        this.onAdd('email');
      }
      else if(email !== "")
      {
        message.error("This email is already registered");
      }
    }

    // set basic details
    if (nextProps.basicDetails && Object.keys(nextProps?.basicDetails).length > 0 && 
      JSON.stringify(nextProps?.basicDetails) !== JSON.stringify(basicDetails)) {
      this.setState({
        basicDetails: nextProps.basicDetails,
        firstName: nextProps?.basicDetails?.firstName,
        lastName: nextProps?.basicDetails?.lastName,
        address: nextProps?.basicDetails?.address,
        phone_numbers: nextProps?.basicDetails?.phone_numbers,
        emails: nextProps?.basicDetails?.emails?.length > 0 ? nextProps?.basicDetails?.emails : null, //[{email: nextProps?.basicDetails?.leadData?.email, primary: true}],
        authorizedUser: nextProps?.basicDetails?.authorizedUser,
        can_send_sms: nextProps?.basicDetails?.can_send_sms,
        hear_about_us: nextProps?.basicDetails?.hear_about_us
      }, () => {
        this.checkZipcode(nextProps?.basicDetails?.zipcode).then(()=>{
          if (nextProps?.zipcodeCheck && Object.keys(nextProps?.zipcodeCheck?.data).length > 0 && nextProps?.zipcodeCheck?.data?.results?.length > 0) {
            this.setState({zipcodeCheck: true, franchises: nextProps?.zipcodeCheck?.data?.results, errors: {}, loader: false}, () => {
            });
          } else {
            this.setState({zipcodeCheck: false, franchises: [], errors: {}, loader: false});
          }
        });
      });
    }
  }
  
  genarateGibberrishEmail = () => {
    let newEmail = [{email: '', primary: true}]
    newEmail[0].email = this.create_UUID() + '@doody.com'
    this.setState({emails:newEmail,is_dummy_email:true});  
  }

  create_UUID = () => {
    let dt = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      let r = (dt + (Math.random()*16))%16 | 0;
      dt = Math.floor(dt/16);
      return (c==='x' ? r :(r&(0x3|0x8))).toString(16);
    });
    return uuid;
  }

  // set address
  setAddress = (addressObject) => {
    const {address} = this.state;
    if (!isEmpty(addressObject)) {
      if (addressObject?.status === "OK") {
        let obj = {}, components = addressObject?.results?.[0];
        map(components?.address_components, (item) => {
          if (item?.types?.includes('administrative_area_level_2')) {
            obj = Object.assign(obj, { 'address': item.short_name })
          }
          if (item?.types?.includes('route')) {
            obj = Object.assign(obj, { 'route': item.short_name })
          }
          if (item?.types?.includes('street_number')) {
            obj = Object.assign(obj, { 'street_number': item.short_name })
          }
          if (item?.types?.includes('administrative_area_level_1')) {
            obj = Object.assign(obj, { 'state': item.short_name })
          }
          if (item?.types?.includes('locality')) {
            obj = Object.assign(obj, { 'city': item.long_name })
          }
          if (item?.types?.includes('postal_code')) {
            obj = Object.assign(obj, { 'zip_code': item.short_name })
          }
        });
        this.setState({address: {...address, ...obj}}, () => {
          if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
            message.error('Please enter valid address');
          }
          this.setState({isLocalValueChanged: true})
        });

      } else {
        message.error('Something went wrong while getting address')
      }
    }
  }

  // Google Map Place API
  handleScriptLoad = () => {

    // Declare Options For Autocomplete
    const options = { componentRestrictions: { country: 'us' } };

    // Initialize Google Autocomplete
    /*global google*/ // To disable any eslint 'google not defined' errors
    const newAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById('google_address'),
      options,
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    newAutoComplete.setFields(['address_components', 'formatted_address', 'geometry', 'icon', 'name']);

    // Fire Event when a suggested name is selected
    newAutoComplete.addListener('place_changed', this.handlePlaceSelect);

    this.setState({
      autocomplete: newAutoComplete,
    })
  };

  removeEmpty=(obj) =>{
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => (v !== null && v?.trim() !== "")));
  }

  // on start place change
  handlePlaceSelect = () => {
    const address= document?.getElementById('google_address')?.value;
    Axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
      params: this.removeEmpty({
        latlng: undefined,
        address,
        key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY,
      })
    }).then((res) => {
      const addressObject = res?.data?.results[0];
      const address = addressObject.address_components;
      let obj = {};
      if (address) {
        map(addressObject?.address_components, (item) => {
          if (item?.types?.includes('administrative_area_level_2')) {
            obj = Object.assign(obj, { 'address': item.short_name })
          }
          if (item?.types?.includes('route')) {
            obj = Object.assign(obj, { 'route': item.long_name })
          }
          if (item?.types?.includes('street_number')) {
            obj = Object.assign(obj, { 'street_number': item.short_name })
          }
          if (item?.types?.includes('administrative_area_level_1')) {
            obj = Object.assign(obj, { 'state': item.short_name })
          }
          if (item?.types?.includes('locality')) {
            obj = Object.assign(obj, { 'city': item.long_name })
          }
          if (item?.types?.includes('postal_code')) {
            obj = Object.assign(obj, { 'zip_code': item.short_name })
          }
        });
        this.setState({ 
          address: (obj?.street_number || obj?.route) ? {...obj, address: `${obj?.street_number || ''} ${obj?.route || ''}`} : obj }, () => {
        }, () => {
        //this.props.resetGeocodeAddress()
        //this.props.getGeocodeAddress({key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY, address})
        });
      }
    }).catch((err) => {
      console.log(err)
    })
  }

  // on service detail change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value }, () => this.setState({isLocalValueChanged: true}))
  }

  // on service detail change
  onTextChangeSource = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;

    this.setState({ [e.target.name]: [value] }, () => this.setState({isLocalValueChanged: true}))
  }

  //on change
  onChange = (row, name) => {
    const {phone_numbers, emails, authorizedUser} = this.state;
    let data = name === 'phone' ? phone_numbers : name === 'email' ? emails : authorizedUser;
    data.splice(row, 1);
    if (name === 'phone' || name === 'email') {
      const idx = data?.findIndex(x => x.primary)
      if (idx <= -1 && !isEmpty(data)) data[0].primary = true
    }
    this.setState({[name === 'phone' ? 'phone_numbers' : name === 'email' ? 'emails' : 'authorizedUser']: data}, () => this.setState({isLocalValueChanged: true}));
    if(name === 'email'){
      if(data.length === 0){
        this.genarateGibberrishEmail()
      }
    }
  };

  // on phone number change
  onPhoneChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value }, () => this.setState({isLocalValueChanged: true}));

    const {phone_numbers} = this.state;
    Object.assign(phone_numbers[0], {[e.target.name]: e.target.checked})
    if (e.target.name === 'type' && e.target.value === 'phone') {
      Object.assign(phone_numbers[0], {'can_send_sms': false})
    }
    this.setState({phone_numbers}, () => {
      console.warn("phone_numbers", this.state.phone_numbers);
    });
  }

  //On add
  onAdd = (name) => {
    const {
      emails = [],
      phone_numbers = [],
      authorizedUser = [],
      user_name,
      phone,
      can_send_sms,
      phone_type,
      email,
      hear_about_us
    } = this.state;

    if (name === 'phone') {
      phone_numbers.push({
        phone: phone,
        can_send_sms,
        primary: phone_numbers?.length === 0,
        type: phone_type
      });
      
      this.setState({phone_numbers}, () => {
        this.setState({isLocalValueChanged: true, phone: '', phone_type: 'mobile', can_send_sms: false})
      });
    } else if (name === 'email') {
      let NewEmails = emails && emails.length && emails.filter(email => {
        return !email.email.includes('doody.com');
      });

      if(email !== '')
      {
        NewEmails.push({email, primary: NewEmails?.length === 0});
        this.setState({emails:NewEmails,is_dummy_email:false}, () => {this.setState({isLocalValueChanged: true, email: ''})});
      }
    } else {
      authorizedUser.push({user_name, created_at: moment().format('MM/DD/YYYY')});
      this.setState({authorizedUser}, () => {this.setState({isLocalValueChanged: true, user_name: ''})});
    }
  };

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // on primary phone number changed
  onPhonePrimaryChanged = (index) => {
    const {phone_numbers} = this.state;
    map(phone_numbers, (obj) => obj.primary = false)
    phone_numbers[index].primary = true
    this.setState({phone_numbers}, () => this.setState({isLocalValueChanged: true}))
  }
  
  // on primary phone number changed
  onEmailPrimaryChanged = (index) => {
    const {emails} = this.state;
    map(emails, (obj) => obj.primary = false)
    emails[index].primary = true
    this.setState({emails}, () => this.setState({isLocalValueChanged: true}))
  }

  // check for logged in user zipcode
  checkedLoggedInUserZipcode = (zipCode) => {
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    if (!isEmpty(authUser) && authUser.user.zip_codes) {
      return authUser.user.zip_codes.includes(zipCode)
    }
    return false
  }

  // on zip code changed
  onZipcodeChange = (e) => {
    this.setState({is_zipcode_change:true});
    this.setState({zipcode: e.target.value, isLocalValueChanged: true}, () => {
      const {zipcode} = this.state;
      if (zipcode.length === 5) {
        this.setState({loader: true})
        this.props.checkZipCode({addressable_zip_codes__contains: zipcode, close: false}) // check zip code)
      } else {
        this.setState({zipcodeCheck: false}, () => this.props.resetCheckZipcode())
      }
    });
  };

  // get franchise for zipcode
  checkZipcode = (value) => {
    if (value && value !== this.state.zipcode) {
      this.setState({loader: true, zipcode: value });
      return this.props.checkZipCode({addressable_zip_codes__contains: value, close: false})
    }
  }

  // format phone number
  formatPhoneNumber = (phone) => {
    if (!phone) return ''
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + ' ' + phone?.substr(3, 3) + ' ' + phone?.substr(6);
  }

  // on address change
  onAddressChange = (e) => {
    const {address} = this.state;
    Object.assign(address, {[e.target.name]: e.target.value})
    this.setState({address});
  };

  // store data in local storage
  storeInLocal = () => 
  {
    const google_address = this.refs['address'] ? this.refs['address'].value: '';
    const {
      phone_numbers,
      emails,
      firstName,
      lastName,
      address,
      zipcode,
      authorizedUser,
      zipcodeCheck,
      is_address_manually,
      is_dummy_email,
      can_send_sms,
      hear_about_us
    } = this.state;
    // sessionStorage.setItem('basicDetail', JSON.stringify({ firstName, lastName, address, phone_numbers, emails, authorizedUser, zipcode, zipcodeCheck, is_address_manually, google_address }))
    this.props.setBasicDetails({
      firstName,
      lastName,
      address,
      phone_numbers,
      emails,
      is_dummy_email,
      authorizedUser,
      zipcode,
      zipcodeCheck,
      is_address_manually,
      google_address,
      can_send_sms,
      hear_about_us
    });
  }

  // validate required fields
  validate = () => {
    const {
      phone_numbers,
      firstName,
      lastName,
      address,
      zipcodeCheck,
      zipcode
    } = this.state;

    let {emails} = this.state;
    emails = emails.filter(item => !item.email.includes("@doody.com"));

    const schema = yup.object().shape({
      zipcode: yup.string().required('Zipcode is required'),
      zipcodeCheck: yup.bool(),
      firstName: yup.string().required('First name is required'),
      lastName: yup.string().required('Last name is required'),
      address: yup.object().shape({
        address: yup.string().required('address is required.'),
        city: yup.string().required('city is required.'),
        state: yup.string().required('state is required.'),
        zip_code: yup.string().test('match', 'zip code is required.', (zip_code) => {
          if (zipcodeCheck) return zip_code //=== zipcode
          return true
        }),
      }),
      // phone_numbers: yup.array(yup.object({
      //   phone: yup.string().required('Phone is required')
      // })).required("Phone number is required"),
      emails: yup.array(yup.object({
        email: yup.string().required('Email is required')
      })).required("Email Address is required"),
    });

    const data = {
      zipcode,
      zipcodeCheck,
      firstName,
      lastName,
      address,
      phone_numbers,
      emails,
    };

    return schema.validate(data, { abortEarly: false }).then(() => {
      this.setState({isBasicDetail: true, errors: {}}, () => {
        this.storeInLocal();
      });
      return Promise.resolve('success');
    }).catch((error) => {
      let err_data = {};
      map(error?.inner, (item) => {err_data[item.path] = item.message})
      this.setState({errors: err_data, isBasicDetail: false});
      return Promise.reject('fail')
    });
  };

  // render all state
  renderAllState = () => {
    return AllState.AllState.map((item, i) => {
      return (<Option value={item.abbreviation} key={i}>{item.name}</Option>)
    });
  }

  // render phone numbers
  renderPhoneNumbers = () => {
    const {phone_numbers, phone, phone_type, can_send_sms, errors, zipcodeCheck} = this.state;
    return (
      <div>
        <h5 className=" mt-30">Phone Numbers</h5>
        <div className="inline-check-list gcheck">
          {
            map(phone_numbers, (item, index) => <div className="fitem-check" key={`phoneNumber${index}`}>
              <input type="radio" className="fitem-ck-input" id={`checkboxPhone${index}`} name={`checkboxPhone${index}`} checked={item?.primary}
                onChange={() => this.onPhonePrimaryChanged(index)} />
              <label htmlFor={`checkboxPhone${index}`} className="fitem-ck-txt black">{`+1 ${this.formatPhoneNumber(item?.phone)} ${item?.primary ? '(Primary)' : ''}`}</label>
              <a className="red float-right" href="/#" onClick={(e) => {e.preventDefault(); this.onChange(index, 'phone')}}><u>Remove</u></a>
            </div>)
          }
        </div>
        <div className="fitem fitem-rinner mt-10 flex">
          <input name="phone" type="text" placeholder="Add New Phone Number" value={phone} maxLength={"10"} disabled={!zipcodeCheck}
            max={"10"} onChange={(e) => this.onNumericInputChange(e.target.value) && this.onTextChange(e)}/>
          <Select
            onChange={(e) => this.onTextChange({target: {name: 'phone_type', value: e}}) }
            style={{marginLeft: "8px", marginRight: "8px"}}
            name="phone_type"
            value={phone_type}
            placeholder="Type">
            <Option value="home_phone">Home</Option>
            <Option value="mobile">Mobile</Option>
          </Select>
          <button className={`btn ${phone.length !== 10 ? 'disabled' : 'btn-warning'}`}
            disabled={phone.length !== 10} onClick={() => this.onAdd('phone')}><PlusOutlined /></button>
        </div>
        {phone_type === 'mobile' ? <div className="fitem-check">
          <input
            type="checkbox"
            name="can_send_sms"
            className="fitem-ck-input"
            checked={can_send_sms}
            id={`can_send_sms`}
            onChange={(e) => this.onPhoneChange(e, 'bool')}
            // onChange={(e) => this.onPhoneChange({target: {name: 'can_send_sms', value: e.target.checked}}), 0}
            
          />
          <label htmlFor={`can_send_sms`} className="fitem-ck-txt">{`Send SMS updates about my service to this number.`}</label>
        </div> : ''}
        {errors?.[`phone_numbers`] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.[`phone_numbers`]}</label> : ''}
      </div>
    )
  }

  // Render email addresses
  renderEmails = () => {
    const {emails, email, errors} = this.state;
    return (
      <div>
        <h5 className=" mt-30">Email Addresses</h5>
        <div className="inline-check-list gcheck">
          {map(emails, (item, index) => item?.email && !item.email.includes('doody.com') ? 
            <div className="fitem-check" key={`email${index}`}>
              <input
                type="checkbox"
                className="fitem-ck-input"
                id={`checkboxEmail${index}`}
                name={`checkboxEmail${index}`}
                checked={item?.primary}
                onChange={() => this.onEmailPrimaryChanged(index)}
              />
              <label
                htmlFor={`checkboxEmail${index}`}
                className="fitem-ck-txt black"
              >
                {`${item?.email} ${item?.primary ? '(Primary)' : ''}`}
              </label>
              <a
                className="red float-right"
                href="/#"
                onClick={(e) => {e.preventDefault(); this.onChange(index, 'email')}}
              >
                <u>Remove</u>
              </a>
            </div> : ''
          )}
        </div>
        <div className="fitem fitem-rinner mt-10">
          <input
            name="email"
            type="text"
            value={email}
            placeholder="Add New Email Address"
            onChange={(e) => this.onTextChange(e)}
          />
          <button
            className={`btn fitem-ricon ${!REGULAR_EXPRESSION_EMAIL.test(email) ? 'disabled' : 'btn-warning'}`}
            disabled={!REGULAR_EXPRESSION_EMAIL.test(email)}
            onClick={() => this.props.checkEmail(email)}
          >
            <PlusOutlined />
          </button>
        </div>
        {errors?.[`emails`] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.[`emails`]}</label> : ''}
      </div>
    )
  };

  // Render Lead source
  renderLeadSource = () => {
    const {hear_about_us} = this.state;
    return (
      <div>
        <h5 className=" mt-30">How did you hear about us</h5>
        <div className="inline-check-list gcheck">
          <Select
            name="hear_about_us"
            value={hear_about_us}
            placeholder="Select the source"
            onChange={(e) => this.onTextChangeSource({ target: { name: 'hear_about_us', value: e } })}
          >
            {aboutUsData?.map((item) => (
                <Option id={item.id} value={item.value} key={item.id}>
                  {item.name}
                </Option>
            ))}
          </Select>
        </div>
      </div>
    )
  };

  // render authorized proposal
  renderAuthorizedUsers = () => {
    const {authorizedUser, user_name, zipcodeCheck} = this.state;
    return (
      <div>
        <h5 className=" mt-30">Authorized Users</h5>
        <div className="inline-check-list gcheck">
          {map(authorizedUser, (item, index) => <div className="fitem-check flex" key={`user${index}`}>
            <b className="d-block">{item?.user_name}</b>
            <div className="flex">
              <span className="mr-2">{`Added ${moment(item?.created_at)?.format('MM/DD/YYYY')}`}</span>
              <a className="red" href={'/#'} onClick={(e) => {e.preventDefault(); this.onChange(index, 'authorizedUser')}}><u>Remove</u></a>
            </div>
          </div>
          )}
        </div>
        <div className="fitem fitem-rinner mt-10">
          <input name="user_name" type="text" placeholder="Add New Authorized User" value={user_name} disabled={!zipcodeCheck}
            onChange={(e) => this.onTextChange(e)}/>
          <button className={`btn fitem-ricon ${!user_name ? 'disabled' : 'btn-warning'}`}
            disabled={!user_name} onClick={() => this.onAdd('authorizedUser')}><PlusOutlined /></button>
        </div>
      </div>
    )
  }

  render() {
    const {
      zipcodeCheck,
      zipcode,
      franchises,
      firstName,
      lastName,
      address,
      errors,
      loader,
      is_address_manually,
      hear_about_us
    } = this.state;
    const franchiseName = franchises?.map((obj) => obj?.name) || [];
    let addressStr = address?.address ? `${address?.address}` : '';
    addressStr += address?.city ? `, ${address?.city}` : '';
    addressStr += address?.state ? `, ${address?.state}` : '';
    addressStr += address?.zip_code ? `, ${address?.zip_code}` : '';
    
    if (this.refs['address']) {
      this.refs['address'].value = addressStr;
    }

    return (
      <div className="aleft">
        {loader && <Loader />}
        <h4>Do we service this area?</h4>
        <p>If you are here, this is for a new customer calling right now. First of all, take their zipcode for their service address to make sure we service this area.</p>
        <div className="form-group">
          <div className="fitem">
            <label>Service Zipcode</label>
            <input type="text" placeholder="Zipcode" name="zipcode" max={5} maxLength={5} value={zipcode || ''}
              onChange={(e) => this.onZipcodeChange(e)}/>
            {errors?.['zipcode'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['zipcode']}</label> : ''}
          </div>
          {zipcode ? zipcodeCheck === true ? <div className="greenbox mb-30">
            <b className="d-block">We cover this area.</b>
            <b className="d-block">{`This is under the ${franchiseName?.toString()} Franchise.`}</b>
          </div> :
            <div className="dangerbox mb-30">
              <b className="d-block">We don’t currently have any franchises covering this area. Save their email to notify them if we move into this area. </b>
            </div> : ''}
        </div>
        <div className="form-group">
          <h4>Contact Information</h4>
          {zipcodeCheck && <div className="fitem half-fitem">
            <div className="fitem half-fitem">
              <label>First Name</label>
              <input type="text" placeholder="First Name" name="firstName" value={firstName} onChange={(e) => this.onTextChange(e)} />
              {errors['firstName'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors['firstName']}</label> : ''}
            </div>
            <div className="fitem half-fitem">
              <label>Last Name</label>
              <input type="text" placeholder="Last Name" name="lastName" value={lastName} onChange={(e) => this.onTextChange(e)} />
              {errors['lastName'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors['lastName']}</label> : ''}
            </div>

            {/* <input type="text" placeholder="Customer Name" name="customerName" value={customerName} onChange={(e) => this.onTextChange(e)}/>
            {errors['customerName'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors['customerName']}</label> : ''} */}
          </div>}
          {zipcodeCheck && <div className="google_search_place fitem">
            <label>Address (Service)</label>
            <Script
              url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
              onLoad={() => window.requestAnimationFrame(this.handleScriptLoad)}
            />

            <input
              autoComplete="off"
              type="text"
              ref="address"
              disabled={(!zipcodeCheck || is_address_manually)}
              className={'form-control mb-10'}
              placeholder={"Location"}
              name="google_address"
              id="google_address"
              onChange={(e) => {
                if (!e.target.value) {
                  this.setState({
                    address: { address: '', state: '', city: '', zip_code: '' }
                  })
                }
              }}
            />
            <b>or <a href="/" onClick={(e) => {
              e.preventDefault();
              this.setState({
                is_address_manually: true,
                address: {address: '', city: '', state: '', zip_code: ''},
              }, () => {
                if (this.refs['address']) {
                  this.refs['address'].value = '';
                } })
            }}><u>enter address manually</u></a></b>
          </div>}
          {
            is_address_manually &&
            <div className="manually_address">
              <a href="/#" onClick={(e) => {
                e.preventDefault();
                this.setState({
                  is_address_manually: false,
                  address: {address: '', city: '', state: '', zip_code: ''},
                })
              }}><img src={cross_icon} alt="" className="float-right mb-10" /></a>
              <br />

              <div className="form-group mb-20">
                <div className="fitem">
                  <input
                    type="text"
                    placeholder="Address"
                    name="address"
                    value={address?.address}
                    onChange={(e) => this.onAddressChange(e)}
                  />
                </div>
                <div className="half-fitem fitem">
                  <div className="half-fitem fitem">
                    <input
                      type="text"
                      placeholder="City"
                      name="city"
                      value={address?.city}
                      onChange={(e) => this.onAddressChange(e)}
                    />
                  </div>
                  <div className="half-fitem fitem" style={{height: "42px !import"}}>
                    <Select
                      showArrow={true}
                      name="state"
                      placeholder="State"
                      onChange={(value) => this.onAddressChange({ target: { name: 'state', value: value } })}
                      value={address?.state || undefined}
                      virtual={false}
                    >
                      {this.renderAllState()}
                    </Select>
                  </div>
                  <div className="half-fitem fitem">
                    <input
                      type="text"
                      className='form--control'
                      placeholder="ZIP Code"
                      name="zip_code"
                      maxLength={5}
                      minLength={5}
                      onChange={(e) => this.onNumericInputChange(e.target.value) && this.onAddressChange(e)}
                      value={address?.zip_code || ''}
                    />
                  </div>
                </div>
              </div>
            </div>
          }
          {(errors?.['address.address'] || errors?.['address.city'] || errors?.['address.state'] || errors?.['address.zip_code'])
            ? <label className="new_err_msg"><i className="las la-info-circle"/>{'Please enter valid address'}</label> : ''}
        </div>
        
        {zipcodeCheck ? this.renderPhoneNumbers() : ''}
        {this.renderEmails()}
        {zipcodeCheck ? this.renderAuthorizedUsers() : ''}
        {this.renderLeadSource()}
      </div>
    )
  }
}

export default BasicDetail;